import ImportRows from './row/components'
import ToggleRows from './ToggleRows'
import PatientRows from './PatientRows'
import patient from '@/module/patient/card/chart/generate/patient'
import Paginator from './row/Paginator'
import DangerIcon from '../../icons/Danger'


export default {
	props: {
		patient: {
			type: Array,
			required: true
		},

		column: {
			type: Object
		},
		columnBack: {
			type: Array
		}
	},


	computed: {
		newPatient() {
			return this.patient.filter((patient) => (! patient.existing && (! patient.invalid || patient.corrected) && !(Array.isArray(patient.data.event) && patient.data.event.some((event) => !event.provider)) ))
		},
		newPatientProfiled() {
			return this.newPatient.filter((patient) => {
				if(patient.data.event && Array.isArray(patient.data.event))
					return patient.data.event.some((event) => event.id || event.profile)
				return false
			})
		},
		existingPatient() {
			return this.patient.filter((patient) => !(Array.isArray(patient.data.event) && patient.data.event.some((event) => !event.provider)) && patient.existing)
		},
		validPatient() {
			return this.patient.filter((patient) => (! patient.invalid))
		},
		invalidPatient() {
			return this.patient.filter((patient) => (patient.invalid))
		},
		invalidProviderFlag() {
			return this.patient.filter((patient) => patient.invalidProvider)
		},
		invalidProvider() {
			return  this.patient.filter((patient) => Array.isArray(patient.data.event) && patient.data.event.some((event) => !event.provider))
		},
		invalidName() {
			return this.invalidPatient.filter((patient) => (patient.data.name == null || patient.data.name.length == 0))
		},
		invalidEmail() {
			return this.invalidPatient.filter((patient) => (patient.data.name != null && patient.data.name.length > 0 && patient.data.email == null))
		},
		incorrectInvalidPatient() {
			return this.invalidPatient.filter((patient) => (! patient.skip && ! patient.corrected))
		},
		importedPatient() {
			return this.patient.filter((patient) => (
                (patient.data && !patient.invalid &&
                (! Array.isArray(patient.data.event) || (Array.isArray(patient.data.reschedule) && patient.data.reschedule.length > 0) ||
				 patient.confirmed == null || patient.confirmed === true || patient.selectedEvent || patient.hasProfile))))
		},
		confirmedPatient() {
			return this.patient.filter((patient) => (
                 (patient.data && !patient.invalid  &&
				 (patient.confirmed == null || patient.confirmed == true || patient.selectedEvent) &&
                 Array.isArray(patient.data.event) ? patient.data.event.length > 0 : false)))
		},
		confirmedEvents() {
			return this.patient.map((patient) => (
                (patient.data && !patient.invalid &&
                (patient.confirmed == null || patient.confirmed === true || patient.selectedEvent) &&
                Array.isArray(patient.data.event)) ? patient.data.event.length : 0)).reduce((a, b) => a + b, 0)
		},
		unconfirmedPatient() {
			return this.patient.filter((patient) => (!patient.invalid && patient.confirmed != null && !patient.invalidProvider))
		},
		scheduledPatient() {
			return this.patient.filter((patient) => (!patient.invalid && !patient.sameSchedule && !patient.reschedule && (patient.confirmed == null || patient.confirmed === true || patient.selectedEvent)))
		},
		unscheduledPatient() {
			return this.patient.filter((patient) => (!patient.invalid && patient.confirmed != null && ! patient.selectedEvent && !patient.invalidProvider))
		},
		newUnscheduledPatient() {
			return this.unscheduledPatient.filter((patient) => !patient.existing && patient.data.event.some((event) => !event.profile) )
		},
		unconfirmedCount() {
			return this.unconfirmedPatient.filter((patient) => !patient.selectedEvent).length
		},
		sameSchedulePatient() {
			return this.patient.filter((patient) => patient.sameSchedule)
		},
		reschedulePatient() {
			return this.patient.filter((patient) => patient.reschedule)
		},
		confirmReschedulePatient() {
			return this.patient.filter((patient) => patient.reschedule && Array.isArray(patient.data.reschedule) && patient.data.reschedule.length > 0)
		},
		totalEventCount() {
			return this.unconfirmedCount + this.confirmReschedulePatient.length + this.confirmedEvents + this.sameSchedulePatient.length
		},
		/**
		 * Calculates patients that need to be connected 
		 * to new providers and profiles
		 */
		connectPatient() {
			try {
				return this.patient.filter((patient) => patient.existing && patient.data.connect && Array.isArray(patient.data.connect) && patient.data.connect.length > 0)
			} catch (error) {
				console.error('Error in getting connect patients', error)
				return []
			}
		}
	},

	components: {
		...ImportRows,
		ToggleRows,
		Paginator,
		PatientRows,
		DangerIcon
	}
}
